import IssueList from "./IssueList";
import Metadata from "./Metadata";
import VolumeDetail from "./VolumeDetail";
import VolumeList from "./VolumeList";
import IssueCount from "./IssueCount";
import JournalIssueCount from "./JournalIssueCount";

export default {
  IssueList,
  Metadata,
  VolumeDetail,
  VolumeList,
  IssueCount,
  JournalIssueCount
};
